import SiteLayout from "@/components/feature/SiteLayout";
import AboutHero from "./components/AboutHero";
import StorySection from "./components/StorySection";
import ValuesSection from "./components/ValuesSection";
import TeamSection from "./components/TeamSection";
import CTASection from "@/pages/site-home/components/CTASection";

export default function SiteAboutPage() {
  return (
    <SiteLayout navVariant="solid">
      <AboutHero />
      <StorySection />
      <ValuesSection />
      <TeamSection />
      <CTASection />
    </SiteLayout>
  );
}